import type { PrefetchContext, PrefetchedDataProps } from '#src/shared/prefetch';

import { getNewsAndGuidesDisableMode } from '#src/app/pages/newsAndGuides/shared/utils';
import { useLocale } from '#src/app/shared/hooks/l10n';
import { useSessionConfiguration } from '#src/app/shared/hooks/sessionConfiguration';

import { prefetchNewsAndGuidesDetailsPageDataFromApi, useNewsAndGuidesDetailsPageDataFromApi } from './pageData';

export type NewsAndGuidesDetailsPagePrefetchedContext = Readonly<{
	pageData: NonNullable<Parameters<typeof useNewsAndGuidesDetailsPageDataFromApi>[0]>;
}>;

export type NewsAndGuidesDetailsPageCombinedState = ReturnType<typeof useNewsAndGuidesDetailsPageDataFromApi>;

export function usePageContext(
	countryCode: string,
	slug: string,
	prefetchedData?: NewsAndGuidesDetailsPagePrefetchedContext,
): NewsAndGuidesDetailsPageCombinedState {
	const locale = useLocale();
	const {
		featureConfigs: { newsAndGuidesVisibility },
	} = useSessionConfiguration();
	const disableMode = getNewsAndGuidesDisableMode(newsAndGuidesVisibility, countryCode);

	return useNewsAndGuidesDetailsPageDataFromApi(prefetchedData?.pageData, { countryCode, locale, slug, disableMode });
}

export async function prefetchPageContext(
	countryCode: string,
	slug: string,
	context: PrefetchContext,
): Promise<NewsAndGuidesDetailsPagePrefetchedContext> {
	const { locale } = context.l10n;
	const disableMode = getNewsAndGuidesDisableMode(
		context.sessionConfiguration.featureConfigs.newsAndGuidesVisibility,
		countryCode,
	);

	return {
		pageData: await prefetchNewsAndGuidesDetailsPageDataFromApi(context, { countryCode, locale, slug, disableMode }),
	};
}

export type NewsAndGuidesDetailsPagePrefetchedDataProps =
	PrefetchedDataProps<NewsAndGuidesDetailsPagePrefetchedContext>;
